import Vue from 'vue';
import Vuex from 'vuex';
import router, { resetRouters } from '@/router';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        currentPathName: '',
        isLoggingOut: false,
        dynamicData: {},
        timestamp: ''
    },
    mutations: {
        setPath(state) {
            state.currentPathName = localStorage.getItem('currentPathName') || '';
        },
        logout(state) {
            if (state.isLoggingOut) return;
            state.isLoggingOut = true;
            localStorage.removeItem('user');
            localStorage.removeItem('menus');
            localStorage.removeItem('currentPathName');
            resetRouters();
            router.push('/login').catch(err => {
                console.error('Logout navigation failed:', err);
            }).finally(() => {
                state.isLoggingOut = false;
            });
        },
        updateTimestamp(state) {
            state.timestamp = new Date().toLocaleString('zh-CN', {
                timeZone: 'Asia/Shanghai',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).replace(/\//g, '-');
        },
        addDynamicData(state, { key, value, timestamp }) {
            const data = state.dynamicData[key] || [];
            data.push({ value, timestamp });
            Vue.set(state.dynamicData, key, data);
        },
        removeDynamicData(state, key) {
            Vue.delete(state.dynamicData, key);
        }
    },
    actions: {
        addDynamicData({ commit, state }, { key, value }) {



            commit('updateTimestamp');
            commit('addDynamicData', { key, value, timestamp: state.timestamp });
        }
    }
});

export default store;